(function () {
  function initReadMore() {
    document.querySelectorAll("[data-read-more-block]").forEach(function (wrapper) {
      var content = wrapper.querySelector("[data-read-more-content]");
      var btn = wrapper.querySelector("[data-read-more-btn]");
      var label = wrapper.querySelector("[data-read-more-label]");
      if (!content || !btn) return;

      var slide = wrapper.closest(".slideshow__slide");
      var blurOverlay = slide ? slide.querySelector("[data-blur-overlay]") : null;

      function checkOverflow() {
        var isDesktop = window.matchMedia("(min-width: 750px)").matches;
        var collapsedLines = isDesktop ? 2 : 4;

        content.setAttribute("data-state", "full");
        var fullHeight = content.scrollHeight;
        content.setAttribute("data-state", "collapsed");

        var lineHeight = parseFloat(getComputedStyle(content).lineHeight) || 20;
        var maxHeight = lineHeight * collapsedLines;

        if (fullHeight <= maxHeight + 4) {
          content.setAttribute("data-state", "full");
          btn.style.display = "none";
        } else {
          btn.style.display = "";
        }
      }

      checkOverflow();

      btn.addEventListener("click", function () {
        var expanded = btn.getAttribute("aria-expanded") === "true";
        if (!expanded) {
          content.setAttribute("data-state", "expanded");
          btn.setAttribute("aria-expanded", "true");
          label.textContent = wrapper.getAttribute("data-read-less-label") || "Read less";
          if (blurOverlay) blurOverlay.classList.add("is-active");
        } else {
          content.setAttribute("data-state", "collapsed");
          btn.setAttribute("aria-expanded", "false");
          label.textContent = wrapper.getAttribute("data-read-more-label") || "Read more";
          if (blurOverlay) blurOverlay.classList.remove("is-active");
        }
      });

      wrapper.setAttribute("data-read-more-label", label.textContent);
      wrapper.setAttribute("data-read-less-label", "Read less");

      window.addEventListener("resize", checkOverflow);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initReadMore);
  } else {
    initReadMore();
  }
})();
